var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestEnvironment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#2c76d3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98 16.99H1.87C1.25 16.99 0.75 16.49 0.75 15.87V1.87C0.75 1.25 1.25 0.75 1.87 0.75H13.87C14.49 0.75 15 1.25 15 1.87V9C15.26 9.05 15.51 9.13 15.75 9.23V1.87C15.75 0.840003 14.91 0 13.87 0H1.87C0.839999 0 0 0.840003 0 1.87V15.87C0 16.9 0.839999 17.74 1.87 17.74H10.73C10.45 17.53 10.2 17.27 9.98 16.99Z",
    fill: "#2c76d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8691 3.98999H4.86914V4.73999H12.8691V3.98999Z",
    fill: "#2c76d3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8691 6.98999H4.86914V7.73999H12.8691V6.98999Z",
    fill: "#2c76d3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86914 9.98999H4.86914V10.74H8.86914V9.98999Z",
    fill: "#2c76d3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86914 12.99H4.86914V13.74H7.86914V12.99Z",
    fill: "#2c76d3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86914 12.99H2.86914V13.74H3.86914V12.99Z",
    fill: "#2c76d3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86914 10H2.86914V10.75H3.86914V10Z",
    fill: "#2c76d3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86914 7H2.86914V7.75H3.86914V7Z",
    fill: "#2c76d3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86914 4H2.86914V4.75H3.86914V4Z",
    fill: "#2c76d3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7509 10.34C15.5209 10.21 15.2609 10.11 15.0009 10.03C14.6409 9.92999 14.2709 9.87 13.8809 9.87C11.6709 9.87 9.88086 11.66 9.88086 13.87C9.88086 15.13 10.4609 16.26 11.3709 16.99C11.8109 17.34 12.3209 17.6 12.8809 17.74C13.2009 17.83 13.5309 17.87 13.8809 17.87C16.0809 17.87 17.8809 16.08 17.8809 13.87C17.8809 12.34 17.0209 11.01 15.7509 10.34ZM15.7509 13.45L15.0009 14.16L13.5509 15.53C13.4809 15.6 13.3909 15.63 13.2909 15.63C13.2009 15.63 13.1009 15.6 13.0309 15.52L11.2309 13.73L11.7609 13.2L13.3009 14.74L15.0009 13.13L15.7509 12.41L16.0909 12.09L16.6109 12.64L15.7509 13.45Z",
    fill: "#2c76d3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestEnvironment);
export default __webpack_public_path__ + "static/media/test-environment.d5e5457e60a49fd81ccc32e5d1a0746c.svg";
export { ForwardRef as ReactComponent };